import {
  ForgotPasswordRequest,
  postForgotPassword,
  SuccessResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import {
  ResponseMessage,
  STATUS_CODE_API_LIMIT,
  STATUS_CODE_SUCCESS,
} from '../../constants';
import { handleApiLimitExceeded, Self } from '../common';

function* forgotPasswordRequest(
  self: Self,
  body: ForgotPasswordRequest
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  self.isLoading = true;
  try {
    const response = yield postForgotPassword(body);
    const { status } = (response as SuccessResponse).data;
    if (status.code === STATUS_CODE_SUCCESS) {
      return ResponseMessage.OK;
    }
    if (status.code === STATUS_CODE_API_LIMIT) {
      handleApiLimitExceeded(self);
    }
    return status.messages[0];
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default forgotPasswordRequest;
